import { Card, CardBody, } from "reactstrap";


type ReusableCardProps = {

  extraInfo?: { [key: string]: string }; // ✅ Dynamic Key-Value Pair
};

const ReusableCard: React.FC<ReusableCardProps> = ({ extraInfo }) => {
  return (
    <Card className="text-center p-1 rounded-3 shadow-sm" style={{ minWidth: "265px",height:'260px',width:'100%' }}>
      <CardBody>
        {extraInfo &&
          Object.entries(extraInfo).map(([key, value], index) => (
            <div key={index}>
              <p className="mb-3" style={{ display: 'flex', justifyContent: 'space-between' }}>
                <strong>{key}</strong> {value}
              </p>
              {index < Object.keys(extraInfo).length - 1 && (
              <hr
              className="my-1"
              style={{
                border: "none",           
                borderTop: "0.3px solid #ddd", 
                height: "0px",             
                margin: "4px 0"           
              }}
            />
              )}
            </div>
          ))}
      </CardBody>
    </Card>
  );
};

export default ReusableCard;

